"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var Styled = _interopRequireWildcard(require("../styles/SideCTA.style"));
var _r10SourceLibrary = require("r10-source-library");
var _constants = require("../../../../utils/constants");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
class CustomFloater extends _react.PureComponent {
  constructor(props) {
    super(props);
  }
  render() {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "gs-app"
    }, /*#__PURE__*/_react.default.createElement(Styled.CustomFloaterContainer, null, /*#__PURE__*/_react.default.createElement(Styled.HeadingContainer, null, /*#__PURE__*/_react.default.createElement(Styled.CustomHeading, {
      "data-test-id": "entry-point-title"
    }, this.props.title), /*#__PURE__*/_react.default.createElement(Styled.TooltipHeader, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.InteractiveIcon, {
      srText: "close-icon",
      dataAttributes: {
        'data-id': 'cta-button-close'
      },
      size: 5,
      onClick: () => {
        this.props.secondaryButtonFunction(_constants.FLOATER_CLOSED_EVENTS.CLOSED_BY_ICON);
      },
      name: "close"
    }))), /*#__PURE__*/_react.default.createElement(Styled.ContentContainer, null, /*#__PURE__*/_react.default.createElement(Styled.TooltipContent, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Paragraph, {
      size: 1,
      weight: 2
    }, /*#__PURE__*/_react.default.createElement(Styled.CustomParagraph, {
      "data-test-id": "entry-point-subtitle"
    }, this.props.content)))), /*#__PURE__*/_react.default.createElement(Styled.Wrapper, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Button, {
      id: "cta-button-cancel",
      width: "full",
      appearance: "secondary",
      text: this.props.secondaryButtonText,
      onClick: () => {
        this.props.secondaryButtonFunction(_constants.FLOATER_CLOSED_EVENTS.CLOLSED_BY_BTN);
      }
    }), /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Button, {
      id: "cta-button-start-journey",
      appearance: "primary",
      width: "full",
      text: this.props.primaryButtonText,
      onClick: () => {
        this.props.primaryButtonFunction();
      }
    }))));
  }
}
exports.default = CustomFloater;